import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=4fc634eb&scoped=true&"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=4fc634eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc634eb",
  null
  
)

export default component.exports